<main *ngIf="data">
  <div class="content">

    <div class="svgContainer contentElement">
      <div class="titles">
        <h1>{{'svgPagePreview'|translation}}</h1>
      </div>
      <div *ngIf="!svgDoc" id="loading">
        <img src="assets/ui/loading.svg" />
      </div>
      <!--  <object #svg [data]="svgUrlSanitize" type="image/svg+xml" (load)="onSvgLoad()"> </object>-->

    </div>
    <div class="idListContainer contentElement">
      <div class="titles">
        <h1>{{'interact'|translation}}</h1>
      </div>
      <div class="subtitles">
        <div class="subtitlesElement">
          <h2>{{'buttons' |translation}}</h2>
          <h3>{{'svgButtonExplain' | translation  }}</h3>
        </div>
        <div class="subtitlesElement">
          <h2>{{'assignedFile' |translation}}</h2>
          <h3>{{'svgAssignedFileExplain' |translation}}</h3>

        </div>
      </div>

      <div class="selectors">
        <ng-container *ngIf="svgIdList?.length > 0; else errorSVGListMessage">
          <ng-container *ngFor="let item of svgIdList">


            <div class="id">
              <div class="selectorsElement poiName">
                <p (mouseover)="highlightSVGElement(item.id)">{{item.id.replace('POI_x5F_', '')}}</p>
              </div>
              <div class="selectorsElement">


                <mat-select [value]="getSelectedMedia(item)" (selectionChange)="setNewMedia(item, $event)">
                  <mat-option value="">Aucun</mat-option>
                  <mat-option *ngFor="let media of this.data.folderContent" [value]="media.id">
                    <p>{{media.displayName}}</p>
                  </mat-option>
                </mat-select>
              </div>
            </div>
            <mat-divider></mat-divider>
          </ng-container>
        </ng-container>
      </div>


      <ng-template #errorSVGListMessage>
        <h2>Aucun ID détecté.<br /> Les IDs doivent contenir 'POI_'.</h2>
      </ng-template>
    </div>

  </div>
  <footer class="footer">

    <div class="buttons">
      <button mat-raised-button color="primary" mat-dialog-close>{{'cancel' | translation}}</button>
      <button mat-raised-button color="accent" [mat-dialog-close]="data.svg">OK</button>

    </div>
  </footer>
</main>
